import { gql } from '@apollo/client';

export const GET_TRQK_SONG_FIELDS = `
    id
    audio_id
    collaborators
    earnings
    entity_id
    percent_share
    percent_shares {
        entity_name
        entity_pro
        entity_role_type
        percent_share
    }
    performance_count
    shows
    statements
    title
    user_id
    work_ids
`;

export const GET_TRQK_SONG = gql`
    query getTrqkSong($id: ID!) {
        getTrqkSong(id: $id) {
            ${GET_TRQK_SONG_FIELDS}
        }
    }
`;
